import React, { useState } from 'react';
import { FaAngleRight } from "react-icons/fa6";
import MemoryModal from '../modals/MemoryModal';
import { useAuth } from '../../../auth/hooks/useAuth';

/**
 * View Memory Button Component
 * Shows a button that opens the memory modal when user asks questions about their memory
 */
const ViewMemoryButton = ({ message, messages }) => {
  const [showModal, setShowModal] = useState(false);
  const { user } = useAuth();

  // Function to detect if the message content suggests the user is asking about their memory
  const shouldShowMemoryButton = (messageText) => {
    if (!messageText || typeof messageText !== 'string') return false;
    
    const lowerText = messageText.toLowerCase();
    const memoryTriggers = [
      'what do you know about me',
      'what do you remember about me',
      'what information do you have about me',
      'what have you learned about me',
      'what do you know',
      'what do you remember',
      'tell me what you know about me',
      'show me what you remember',
      'what personal information',
      'what details do you have',
      'my information',
      'my details',
      'my data',
      'stored about me',
      'saved about me',
      'remember about me',
      'know about me'
    ];
    
    return memoryTriggers.some(trigger => lowerText.includes(trigger));
  };

  // Find the user message that prompted this bot response
  const getUserMessageForBotResponse = () => {
    if (!messages || !Array.isArray(messages)) return null;
    
    const currentIndex = messages.findIndex(msg => msg._id === message._id);
    if (currentIndex === -1) return null;
    
    // Look backwards for the most recent user message
    for (let i = currentIndex - 1; i >= 0; i--) {
      if (messages[i].sender === 'user') {
        return messages[i];
      }
    }
    return null;
  };

  // Check if this is a bot message responding to a memory-related question
  if (message?.sender !== 'bot') {
    return null;
  }

  const userMessage = getUserMessageForBotResponse();
  if (!userMessage || !shouldShowMemoryButton(userMessage?.text)) {
    return null;
  }

  const handleClick = () => {
    console.log('🧠 ViewMemoryButton: Click detected, opening memory modal');
    setShowModal(true);
  };

  return (
    <>
      <div className="mt-1 mb-3">
        <button
          onClick={handleClick}
          className="inline-flex items-center gap-1.5 pl-3 pr-3 py-2 text-xs font-semibold text-white dark:text-black bg-black dark:bg-white hover:bg-[#1a1a1a] dark:hover:bg-[#f0f0f0] border rounded-full transition-colors duration-200 group"
          title="View all saved memories"
        >
          <span>View Saved Memory</span>
          <FaAngleRight className="w-3 h-3 text-white dark:text-black group-hover:translate-x-0.5 transition-transform duration-200" />
        </button>
      </div>

      {/* Memory Modal */}
      <MemoryModal 
        isOpen={showModal}
        onClose={() => {
          console.log('🧠 ViewMemoryButton: Modal onClose called, setting showModal to false');
          setShowModal(false);
        }}
        userId={user?.id}
      />
    </>
  );
};

export default ViewMemoryButton;
